export class CVParams {
    search: string;
    pageNo: number = 1;
    pageSize: number = 5;
    pageLength: number = 10;
    customerID: number;
    coreSPID: string;
    telephoneNumber: string;
    Postcode: string;
    emailID: string;
    totalRecord: string;
    rownumber: string;

}
export class Customerverification {
    serach: string;
    PageNo: number = 1;
    PageSize: number = 5;
    pageLength: number = 10;
    customerID: number | "";
    coreSPID: string;
    telephoneNumber: string;
    emailID: string;
    totalRecord: string;
    rownumber: string;
    user_id: number;
    Postcode: string;
}
export class clsPartnerlist {
    cust_Id: number;
    quoteID: number;
    full_Customer_Name: string;
    partnerName: string;
    contractTerm: string;
    waterSPID: string;
    wasterSPID: string;
    business_name: string;
    cSD: string;
    cED: string;
    contractFileName: string;
    contractFileFullPath: string;
    approvalStatus: string;
    customerType: string;
    totalRecord: string;
    rownumber: string;
    currentstatus: string;
    cot_process_indicator:number;
    title:string;
}
export interface PagingConfig {
    currentPage: number;
    itemsPerPage: number;
    totalItems: number;
}
export class Cvlist {
    cust_Id: number;
    quoteID: number;
    full_Customer_Name: string;
    partnerName: string;
    contractTerm: string;
    waterSPID: string;
    wasterSPID: string;
    business_name: string;
    cSD: string;
    cED: string;
    contractFileName: string;
    contractFileFullPath: string;
    approvalStatus: string;
    customerType: string;
    totalRecord: string;
    rownumber: string;
}

export class GlobalSearch {
    search: string;
    pageNo: number = 1;
    pageSize: number = 5;
    pageLength: number = 10;
    customerID: number;
    coreSPID: string
    waterSPID: string
    SPID: string
    user_id: number;

}

export class customercvaccountcheck {
    user_id: number;
    Id: number;

}

export class spidverfication {
    spid: string;
    user_id: number;
    type: string;
}